import AdminInventory from "@/components/AdminInventory";
import { PageTitle } from "@/admin/ui";

export default function Inventory() {
  return (
    <div data-testid="admin-inventory-page">
      <PageTitle title="Inventory" sub="Per-size availability. Restocking a size automatically emails everyone waiting." />
      <div className="[&>div]:mt-0">
        <AdminInventory />
      </div>
    </div>
  );
}
